import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get values() {
    return { count: Number }
  }

  connect() {
    this.dispatch("loaded", { detail: { count: this.countValue } })
  }
}
